<template>
	<div class="wizard form">
		<el-steps :active="step" finish-status="success" align-center>
		  <el-step title="Enroll Patients" description="Confirm patient information"></el-step>
		  <el-step title="Schedule Events" description="Confirm follow ups and procedures"></el-step>
		  <el-step title="Confirm"></el-step>
		</el-steps>

		<div v-if="step == 0" class="dialog">
			<p v-if="parsing">
				Please wait while we extract patients from the spreadsheet...
			</p>
			<p v-else>
				<el-button @click.native="nextStep" size="large" type="primary">
					Next
				</el-button>
				Please confirm the {{ count }} patients extracted from the spreadsheet.
			</p>
		</div>
		<div v-else-if="step == 1" class="dialog">
			<p>
				<el-button @click.native="nextStep" size="large" type="primary">
					Next
				</el-button>
				<el-button @click.native="previousStep" size="large" type="primary" plain>
					Back
				</el-button>
				Please confirm the scheduled events extracted from the spreadsheet.
			</p>
		</div>
		<div v-else class="dialog">
			<p>
				<el-button @click.native="confirmImport" size="large" type="primary">
					Start Import
				</el-button>
				<el-button @click.native="previousStep" size="large" type="primary" plain>
					Back
				</el-button>
				Please confirm everything is correct, then click to start importing.
			</p>
		</div>
	</div>
</template>
<script>
export default {
	name: 'import-patient-wizard',

	props: ['value', 'count', 'parsing'],

	data() {
		return { step: this.value }
	},

	methods: {
		changed() {

		},
		previousStep() {
			this.step--
			this.$emit('input', this.step)
		},
		nextStep() {
			this.step++
			this.$emit('input', this.step)
		},
		confirmImport() {

		}
	}
}
</script>

<style lang="scss" scoped>
.wizard {
	margin-top: 20px;
	padding-top: 25px;

	.dialog {
		background:#f0f0f0;
		border-radius:4px;
		padding:20px 25px;
		margin:10px 0;

		p {
			font-size:18px;
			font-weight:700;

			.el-button {
				float:right;
				margin-top: -12px;
				margin-right: -15px;
				font-weight:700;
			}
			.el-button + .el-button {
				margin-right: 5px;
			}
		}
	}

}
</style>
